module.exports = __webpack_public_path__ + "img/systemLog.d23734a0.svg";